import config from '../../config'
import { buildGetQuery } from '../../util'

import { ISafetyReportPortalConfig, IGetRequestObject } from '../../interfaces'

type Params = {
  portalKey: string
}

const request = (params: Params): IGetRequestObject => {
  const { portalKey } = params

  return {
    method: 'get',
    url: `${config.baseUrl}/sms/SafetyReport/${portalKey}/config`,
  }
}

const useSafetyReportConfigByPortalKey = buildGetQuery<Params, undefined, ISafetyReportPortalConfig | undefined>({
  getRequest: request,
  getQueryKey: params => ['safety-report-config-by-portal-key', params.portalKey],
})

export default useSafetyReportConfigByPortalKey
